// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"156":"7bd1939a","168":"6da51707","289":"83a3f840","461":"35dc1859","463":"8b5d83c3","931":"b16a829c","936":"ff92a6f2"}[chunkId] + ".js";
};